module.exports = __webpack_public_path__ + "img/autoclicker-avatar.13fc2bf3.png";